import {useNavigate} from 'react-router';
import type {FullManifestation} from 'services/metadata/types';
import {
  useLazyGetManifestationByEanQuery,
  useLazyGetManifestationByIsbnQuery,
} from 'services/metadata';

export type SearchError = 'notFound' | 'invalidLength';

export type GlobalSearch = {
  search: (
    query: string,
  ) => Promise<FullManifestation | SearchError> | SearchError | undefined;
  navigateToManifestation: (manifestation: FullManifestation) => void;
};

export const useGlobalSearch = (): GlobalSearch => {
  const navigate = useNavigate();

  const [getManifestationByEanQuery] = useLazyGetManifestationByEanQuery();
  const [getManifestationByIsbnQuery] = useLazyGetManifestationByIsbnQuery();

  const navigateToManifestation = (manifestation: FullManifestation) => {
    navigate(
      `/metadata/${manifestation.workId}?manifestationId=${manifestation.id}&isbn=${manifestation.isbn}`,
    );
  };

  const search = (
    query: string,
  ): Promise<FullManifestation | SearchError> | SearchError | undefined => {
    const cleanedQuery = query.trim().replaceAll('-', '');
    if (cleanedQuery.length !== 13) {
      return 'invalidLength';
    }

    return getManifestationByIsbnQuery(cleanedQuery)
      .unwrap()
      .then(manifestation => {
        if (manifestation) {
          return manifestation;
        }

        return getManifestationByEanQuery(cleanedQuery)
          .unwrap()
          .then(manifestation => {
            if (manifestation) {
              return manifestation;
            }

            return 'notFound';
          });
      });
  };

  return {
    search,
    navigateToManifestation,
  };
};
